import React from "react";
import { DotLegalAlert, DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import { useEditBestPracticeDocumentTemplateDialog, EditBestPracticeDocumentTemplateDialogProps } from "./EditBestPracticeDocumentTemplateDialog.hooks";
import { isNullOrWhitespace } from "../../common/stringOperations";
import DotLegalFileUploadWrapper from "../../common/components/dotLegalFileUpload/DotLegalFileUploadWrapper";
import { Box } from "@mui/material";
import { useAiSpendingWarning } from "../../aiAdministration/AiAdministration.hooks";
import { isAiSpendingExhausted } from "../../aiAdministration/AiAdministration.types";
import AiSpendingWarningAlert from "../../aiAdministration/AiSpendingWarningAlert";
import UploadProgressBar from "@common/components/uploadProgress/UploadProgressBar";

function EditBestPracticeDocumentTemplateDialog(props: EditBestPracticeDocumentTemplateDialogProps) {
    const { translateString } = useTranslation();
    const { viewModel, onNameChange, onFileChange, showError, inProgress, isUploading, uploadPercentage, onOkClick } =
        useEditBestPracticeDocumentTemplateDialog(props);
    const { data: spendingWarning } = useAiSpendingWarning();
    const isAiExhausted = isAiSpendingExhausted(spendingWarning);

    return (
        <DotLegalDialog
            header={translateString("editBestPracticeDocumentTemplate")}
            size="sm"
            buttonOkText={translateString("save")}
            open
            onDialogClose={props.onDialogClose}
            onOkClick={onOkClick}
            inProgress={inProgress}
            disableBackdropOnCloseIfValueChange={viewModel}
            okButtonDisabled={isAiExhausted}
        >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <DotLegalTextField
                    debounce={false}
                    label={translateString("name")}
                    value={viewModel.name}
                    onChange={onNameChange}
                    noMargin
                    errorText={showError && isNullOrWhitespace(viewModel.name) ? translateString("fieldRequired") : undefined}
                    disabled={isAiExhausted}
                />

                <DotLegalAlert warningText={translateString("editBestPracticeDocumentTemplateWarning")} />

                <DotLegalFileUploadWrapper
                    files={viewModel.fileName ? [viewModel.fileName] : []}
                    onFilesChanged={onFileChange}
                    isLoading={false}
                    disabled={isAiExhausted}
                />

                <UploadProgressBar isUploading={isUploading} uploadPercentage={uploadPercentage} />

                <AiSpendingWarningAlert warning={spendingWarning} />
            </Box>
        </DotLegalDialog>
    );
}

export default EditBestPracticeDocumentTemplateDialog;
